import React, { useMemo } from 'react';
import { useRouter } from '@atlassian/jira-router';
import {
	LastOpenedConfigTab,
	boardSettingsQueryConfigParamValues,
	useIsUserLocatedBoard,
	useIsKanbanBoard,
	SettingsContainer,
	useIsJSMBoard,
} from '@atlassian/jira-software-board-settings-rapidboard-config-common';
import RapidBoardCardColoursSettings from '@atlassian/jira-spa-apps-classic-board-settings-card-colours';
import RapidBoardCardLayoutSettings from '@atlassian/jira-spa-apps-classic-board-settings-card-layout';
import RapidBoardColumnsSettings from '@atlassian/jira-spa-apps-classic-board-settings-columns';
import RapidBoardEstimationSettings from '@atlassian/jira-spa-apps-classic-board-settings-estimation';
import RapidBoardGeneralSettings from '@atlassian/jira-spa-apps-classic-board-settings-general';
import RapidBoardQuickFiltersSettings from '@atlassian/jira-spa-apps-classic-board-settings-quick-filters';
import RapidBoardSwimlanesSettings from '@atlassian/jira-spa-apps-classic-board-settings-swimlanes';
import RapidBoardTimelinesSettings from '@atlassian/jira-spa-apps-classic-board-settings-timeline';
import RapidBoardWorkingDaysSettings from '@atlassian/jira-spa-apps-classic-board-settings-working-days';

export const BoardConfigSwitcher = () => {
	const [{ query }] = useRouter();
	const isUserLocatedBoard = useIsUserLocatedBoard();
	const isKanban = useIsKanbanBoard();
	const isJsm = useIsJSMBoard();

	const configToPageMap: Record<string, React.FC> = useMemo(
		() => ({
			[boardSettingsQueryConfigParamValues.filter]: RapidBoardGeneralSettings,
			[boardSettingsQueryConfigParamValues.columns]: RapidBoardColumnsSettings,
			[boardSettingsQueryConfigParamValues.swimlanes]: RapidBoardSwimlanesSettings,
			[boardSettingsQueryConfigParamValues.quickFilters]: RapidBoardQuickFiltersSettings,
			[boardSettingsQueryConfigParamValues.cardColors]: RapidBoardCardColoursSettings,
			[boardSettingsQueryConfigParamValues.cardLayout]: RapidBoardCardLayoutSettings,
			[boardSettingsQueryConfigParamValues.time]: RapidBoardWorkingDaysSettings,
			...(!isKanban && {
				[boardSettingsQueryConfigParamValues.estimation]: RapidBoardEstimationSettings,
			}),
			...(!isUserLocatedBoard && {
				[boardSettingsQueryConfigParamValues.timelineConfig]: RapidBoardTimelinesSettings,
			}),
		}),
		[isKanban, isUserLocatedBoard],
	);

	const ConfigPage = useMemo(() => configToPageMap[query.config], [configToPageMap, query.config]);

	return ConfigPage ? (
		<SettingsContainer packageId={`jira-board-settings.${query.config}-settings-route`}>
			<ConfigPage />
		</SettingsContainer>
	) : (
		<LastOpenedConfigTab
			configParam={query.config}
			isUserLocatedBoard={isUserLocatedBoard}
			isKanban={isKanban}
			isJsm={isJsm}
		/>
	);
};
